import NextWrapper from '@/components/layouts/Containers/NextWrapper/NextWrapper';
import { Mortgage } from '@/reactPages/Mortgage';
import MortgageRules from '@/reactPages/MortgageRules/MortgageRules';

export const meta = {
  title: 'Ипотека на сахалине',
};

const MortgagePage = () => {
  return (
    <>
      <NextWrapper meta={meta}></NextWrapper>
      <MortgageRules></MortgageRules>
    </>
  );
};

export default MortgagePage;
